import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { CONCERT_KEYS } from "~/api/cache"

import type { ConcertPricingResponseDto } from "../../../dto/concert.dto"
import { concertService } from "../../../services/concert.service"

export const useGetConcertPricing = (
  proposalId: string,
): UseQueryResult<ConcertPricingResponseDto, unknown> => {
  return useQuery({
    queryKey: CONCERT_KEYS.pricing(proposalId),
    queryFn: () => concertService.getPricing(proposalId),
    enabled: !!proposalId,
  })
}
